
import { Modal } from "../components/Modal";
import FilesApi from "../../api/files.js";
import goals from "../../utils/goals.js";

export class RegionPaymentModal extends Modal {
    init() {
        super.init();
        this.continueBtn.on('click', this.onContinue.bind(this));
        this.redirectBtn.on('click', this.onRedirect.bind(this));
    }

    show(target, isPost = false) {
        this.isPost = isPost;
        this.target = target;

        goals.reach('showedRedirect')
        super.show();
    }

    onContinue() {
        this.hide();
        if (!this.isPost) {
            window.location.href = this.target;
            return;
        }

        FilesApi.transcribe(this.target);
    }

    onRedirect() {
        goals.reach('acceptedRedirect')

        this.hide();
        if (!this.isPost) {
            window.location.href = this.target + '&external=true';
            return;
        }

        this.target.external = true;
        FilesApi.transcribe(this.target);
    }
}




